import { render, staticRenderFns } from "./InstagramMetricCard.vue?vue&type=template&id=263ebbef&scoped=true&"
import script from "./InstagramMetricCard.vue?vue&type=script&lang=js&"
export * from "./InstagramMetricCard.vue?vue&type=script&lang=js&"
import style0 from "./InstagramMetricCard.vue?vue&type=style&index=0&id=263ebbef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263ebbef",
  null
  
)

export default component.exports